import { $$, REDUCED } from '../lib/dom.js';

export function initCountUp() {
  const cells = $$('.hero-stats .value');
  cells.forEach(el => {
    if (el.id === 'sleep-counter') return;
    const text = el.textContent.trim();
    const m = text.match(/^([\d,]+)(.*)$/);
    if (!m) return;
    el.dataset.target = parseInt(m[1].replace(/,/g, ''), 10);
    el.dataset.suffix = m[2];
    el.textContent = '0' + m[2];
  });

  if (REDUCED) {
    cells.forEach(el => {
      if (el.dataset.target) {
        el.textContent = (+el.dataset.target).toLocaleString() + (el.dataset.suffix || '');
      }
    });
    return;
  }

  const io = new IntersectionObserver(entries => {
    entries.forEach(en => {
      if (!en.isIntersecting) return;
      const el = en.target;
      if (el.dataset.done) return;
      el.dataset.done = '1';
      const target = +el.dataset.target;
      const suffix = el.dataset.suffix || '';
      const dur = 1400;
      const t0 = performance.now();
      const tick = t => {
        const k = Math.min(1, (t - t0) / dur);
        const eased = 1 - Math.pow(1 - k, 3);
        el.textContent = Math.floor(target * eased).toLocaleString() + suffix;
        if (k < 1) requestAnimationFrame(tick);
        else el.textContent = target.toLocaleString() + suffix;
      };
      requestAnimationFrame(tick);
      io.unobserve(el);
    });
  }, { threshold: 0.3 });

  cells.forEach(el => { if (el.dataset.target) io.observe(el); });
}
